import { BAND_PATHS } from "Bands/router";
import { EventBlocksType, IBirthdayEvent, IEvent, IIconBandSetting } from "Bands/types";
import { useBandRoute } from "Bands/utils";
import { copy } from "shared/assets";
import { Plus } from "shared/assets/icons";
import { CalendarBirthday, CalendarItem } from "shared/components";
import { Icon } from "shared/styles";

import { IFormOption } from "shared/types";
import { AddEventButton, DayNumberProps, StyledDay, StyledDayNumber } from "./styles";

interface CalendarDayProps extends DayNumberProps {
  day: number;
  events?: IEvent[];
  bandCalendar?: boolean;
  canAddEvent?: boolean;
  date?: string;
  bandId?: string | null;
  birthdays?: IBirthdayEvent[];
  setSelectedEventBlocks?: (events: IFormOption[]) => void;
  setSelectedSourceEvent?: (events: IEvent | null) => void;
  blockType?: EventBlocksType;
  infoBlockType?: IIconBandSetting;
}

export const CalendarDay = ({
  day,
  events,
  isDisabled,
  isActive,
  bandCalendar,
  canAddEvent,
  date,
  bandId,
  birthdays,
  setSelectedEventBlocks,
  setSelectedSourceEvent,
  blockType,
  infoBlockType,
}: CalendarDayProps) => {
  const { pushRoute } = useBandRoute();

  return (
    <StyledDay extraPadding={canAddEvent}>
      <StyledDayNumber isActive={isActive} isDisabled={isDisabled}>
        {day}
      </StyledDayNumber>
      {!setSelectedEventBlocks &&
        birthdays?.map(bday => <CalendarBirthday key={`bday${bday.id}`} birthday={bday} />)}
      {events?.map(event => (
        <CalendarItem
          key={event.id}
          event={event}
          showBand={!bandCalendar}
          setSelectedEventBlocks={setSelectedEventBlocks}
          setSelectedSourceEvent={setSelectedSourceEvent}
          blockType={blockType}
          infoBlockType={infoBlockType}
        />
      ))}
      {!setSelectedEventBlocks && canAddEvent && (
        <AddEventButton
          size="s"
          className="calendar-add-event-button"
          data-testid="calendar-add-event-button"
          onClick={() =>
            date &&
            bandId &&
            pushRoute(`${BAND_PATHS.CREATE_BAND_EVENT}?date=${date}`, {
              bandId,
            })
          }
        >
          <Icon as={Plus} />
          <span>{copy.event.title}</span>
        </AddEventButton>
      )}
    </StyledDay>
  );
};
